import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-10eb603a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-bar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "木亘OJ")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "user-info"
}
const _hoisted_3 = { class: "user-avatar-wrap" }
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = {
  key: 1,
  class: "auth-buttons"
}

import { routes } from "../router/routes";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import checkAccess from "@/access/checkAccess";
import ACCESS_ENUM from "@/access/accessEnum";
import {
  IconUser,
  IconSettings,
  IconExport,
} from "@arco-design/web-vue/es/icon";
import message from "@arco-design/web-vue/es/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter();
const store = useStore();

const loginUser = computed(() => store.state.user.loginUser);

// 展示在菜单的路由数组
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    if (item.meta?.hideInMenu) {
      return false;
    }
    if (
      !checkAccess(store.state.user.loginUser, item?.meta?.access as string)
    ) {
      return false;
    }
    return true;
  });
});

// 默认主页
const selectedKeys = ref(["/"]);

// 路由跳转后，更新选中的菜单项
router.afterEach((to) => {
  selectedKeys.value = [to.path];
});

const doMenuClick = (key: string) => {
  router.push({ path: key });
};

const doLogout = async () => {
  const res = await store.dispatch("user/logout");
  if (res) {
    message.success("已退出登录");
    router.push({ path: "/", replace: true });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "120px" }, {
        default: _withCtx(() => [
          (loginUser.value?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_a_dropdown, { trigger: "click" }, {
                  content: _withCtx(() => [
                    _createVNode(_component_a_doption, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/user/profile')))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(IconUser))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 个人中心 ")
                      ]),
                      _: 1
                    }),
                    (loginUser.value.userRole === _unref(ACCESS_ENUM).ADMIN)
                      ? (_openBlock(), _createBlock(_component_a_doption, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/manage/question/')))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(IconSettings))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 管理后台 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_doption, {
                      class: "logout-option",
                      onClick: doLogout
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(IconExport))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 退出登录 ")
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_a_avatar, {
                        size: 32,
                        class: "user-avatar"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(loginUser.value.userName?.substring(0, 1)), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(loginUser.value.userName), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_a_button, {
                  type: "text",
                  size: "small",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/user/login')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 登录 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/user/register')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 注册 ")
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})